import { API } from "../constants/api";
import { axiosPostWithToken, axiosGetWithToken } from "../services/apiServices";
import { ERROR_ALERT, SUCCESS_ALERT } from "./commonAction";

export const GET_FINAL_CANDIDATE = "GET_FINAL_CANDIDATE";
export const FINAL_CANDIDATE_LOADING = "FINAL_CANDIDATE_LOADING";
export const SET_FINAL_CANDIDATE_ITEMS_PER_PAGE =
  "SET_FINAL_CANDIDATE_ITEMS_PER_PAGE";
export const CHANGE_CURRENT_FINAL_CANDIDATE_PAGE =
  "CHANGE_CURRENT_FINAL_CANDIDATE_PAGE";
export const SEARCH_FINAL_CANDIDATE = "SEARCH_FINAL_CANDIDATE";
export const FILTER_FINAL_CANDIDATE_ROLES = "FILTER_FINAL_CANDIDATE_ROLES";
export const FILTER_FINAL_CANDIDATE_SKILL = "FILTER_FINAL_CANDIDATE_SKILL";
export const FILTER_FINAL_CANDIDATE_STATUS = "FILTER_FINAL_CANDIDATE_STATUS";
export const VIEW_CLIENT_FEEDBACK = "VIEW_CLIENT_FEEDBACK";
export const RESET_FINAL_TABLE_FILTERS = "RESET_FINAL_TABLE_FILTERS";

export const getFinalCandidates = (projectId, closeModal) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    const pagesize =
      getstate().finalSelectionCandidates.FinalCandidateResultsPerPage;
    const page = getstate().finalSelectionCandidates.FinalCandidateCurrentPage;
    const searchText =
      getstate().finalSelectionCandidates.FinalCandidateSearchText;
    const roles =
      getstate().finalSelectionCandidates.FinalCandidateAppliedRolesFilter;
    const skills =
      getstate().finalSelectionCandidates.FinalCandidateAppliedSkillFilter;
    const status =
      getstate().finalSelectionCandidates.FinalCandidateAppliedStatusFilter;

    const body = {
      search_term: searchText,
      filter_data: {
        roles: roles,
        skills: skills,
        status: status,
      },
    };

    axiosPostWithToken(
      `${API.FINAL_SELECTION_LIST}/${projectId}/${pagesize}/${page}/`,
      body,
      token
    ).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: GET_FINAL_CANDIDATE,
          payload: res.data.data,
        });
        if (closeModal) {
          closeModal();
        }
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            (res && res.data && res.data.data && res.data.data.message) ||
            "Something went wrong. Unable to fetch data",
        });
      }
    });
  };
};

export const viewClientFeedback = (id, toggleModal) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    axiosGetWithToken(`${API.VIEW_CLIENT_FEEDBACK}/${id}/`, token).then(
      (res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: VIEW_CLIENT_FEEDBACK,
            payload: res.data.data,
          });
          toggleModal("viewUpdateModal", res.data.data);
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload:
              (res && res.data && res.data.data && res.data.data.message) ||
              "Something went wrong. Unable to fetch data",
          });
        }
      }
    );
  };
};
export const updateClientFeedback = (body, assignment_id, refresh) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;

    axiosPostWithToken(
      `${API.UPDATE_CLIENT_FEEDBACK}/${assignment_id}/`,
      body,
      token
    ).then((res) => {
      if (res.data.status_code === 200) {
        refresh();
        dispatch({
          type: SUCCESS_ALERT,
          payload: "Updated Successfully",
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            (res.data && res.data.data && res.data.data.message) ||
            "Something went wrong. Unable to process request.",
        });
      }
    });
  };
};

export const setItemsPerPage = (value) => {
  return async (dispatch) => {
    dispatch({
      type: FINAL_CANDIDATE_LOADING,
    });
    dispatch({
      type: SET_FINAL_CANDIDATE_ITEMS_PER_PAGE,
      payload: value,
    });
  };
};

export const changeCurrentPage = (value) => {
  return async (dispatch) => {
    dispatch({
      type: FINAL_CANDIDATE_LOADING,
    });
    dispatch({
      type: CHANGE_CURRENT_FINAL_CANDIDATE_PAGE,
      payload: value,
    });
  };
};

export const search = (value) => {
  return async (dispatch) => {
    dispatch({
      type: FINAL_CANDIDATE_LOADING,
    });
    dispatch({
      type: SEARCH_FINAL_CANDIDATE,
      payload: value,
    });
  };
};

export const filterStatus = (status) => {
  return async (dispatch) => {
    dispatch({
      type: FINAL_CANDIDATE_LOADING,
    });
    dispatch({
      type: FILTER_FINAL_CANDIDATE_STATUS,
      payload: status,
    });
  };
};

export const filterRoles = (roles) => {
  return async (dispatch) => {
    dispatch({
      type: FINAL_CANDIDATE_LOADING,
    });
    dispatch({
      type: FILTER_FINAL_CANDIDATE_ROLES,
      payload: roles,
    });
  };
};

export const filterSkills = (skills) => {
  return async (dispatch) => {
    dispatch({
      type: FINAL_CANDIDATE_LOADING,
    });
    dispatch({
      type: FILTER_FINAL_CANDIDATE_ROLES,
      payload: skills,
    });
  };
};

export const resetTableData = () => {
  return async (dispatch) =>{
    dispatch({
      type: RESET_FINAL_TABLE_FILTERS,
    });
  };
};
